import { NumberRangeBase } from "../abstract/number-range.model";

export class AccountEntryNumberRange extends NumberRangeBase {
    static override CLASS_NAME: string = 'AccountEntryNumberRange';
}